import { AbstractListMap, ListAddObjectParams, ListMapOptions } from "./abstractListMap";

/**
 * creates map[key] if it does not exists
 * @returns map[key] or created array
 */
export function createArrayMapEntryIfUndefined<K, T>(map: Map<K, T[]>, key: K): T[] {
	let arr = map.get(key);
	if (!arr) { arr = []; map.set(key, arr); }
	return arr;
}

/**
 * map[key].push(value); and creates map[key] if it does not exists
 */
export function addToArrayMap<K, T>(map: Map<K, T[]>, key: K, value: T): void {
	createArrayMapEntryIfUndefined(map, key).push(value);
}

/**
 * Equivalent to Map<K, T[]> with specialized functions
 * 
 * ! when setting options.acceptNullKey to true you MUST define K as nullable => ArrayMap<Key|undefined,T>
 */
export class ArrayMap<K, T> extends AbstractListMap<K, T, T[]> {

	/**
	 * @override
	 */
	constructor(
		options: ListMapOptions,
		addObjects?: ListAddObjectParams<K, T>
	) {
		super(options, addObjects);
	}

	/**
	 * @override
	 */
	public addEntry(key: K, o: T): void {
		addToArrayMap(this, key, o);
	}

}